export default {
    path: 'questionnaire',
    component: () => import('@/pages/questionnaire/list'),
    meta: {title:'调查问卷列表'},
	children: [
        {
            path: '/questionnaire/info',
            component: () => import('@/pages/questionnaire/info'),
            meta: {
                title: '问卷调查详情'
            },
        }
	]
}